export default __webpack_public_path__ + "static/media/landing-write-chat.1698e6ca.svg";